import React, { useState } from "react";
import { createStyles, WithStyles, withStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Form from "./form/Form";
import { FiniteStateMachineObject } from "figma-fsm/lib/transformations/transformCanvasToFiniteStateMachine";
import About from "./About";
import MachinesContainer from "./machine/MachinesContainer";
import Spinner from "react-spinkit";

export interface MainProps extends WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    main: {
      height: "100%",
      minHeight: "calc(100vh - 72px)",
      padding: "24px 24px 72px"
    },
    about: {
      maxWidth: "500px",
      textAlign: "center"
    },
    aboutTitle: {
      margin: "48px 0 24px"
    },
    helperText: {
      marginTop: "24px"
    },
    spinner: {
      color: theme.palette.secondary.main,
      marginTop: "24px"
    }
  });

const Title = () => (
  <Typography variant="h4" color="inherit">
    Turn your <Link href="https://www.figma.com">Figma Prototypes</Link> into Finite State Machine
    objects
  </Typography>
);

const Main = ({ classes }: MainProps) => {
  const [figmaFsmResult, setFigmaFsmResult] = useState<ReadonlyArray<FiniteStateMachineObject>>([]);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      className={classes.main}
    >
      <Title />
      <Typography className={classes.helperText} variant="body1">
        You can create an Access Token as explained here:{" "}
        <Link href="https://www.figma.com/developers/docs#authentication" target="_blank">
          Figma API Docs
        </Link>{" "}
        {
          "& your file-key is on the figma url like: https://www.figma.com/file/<file-key>/<file-name>"
        }
      </Typography>
      <Form setFigmaFsmResult={setFigmaFsmResult} setIsLoading={setIsLoading} />
      {isLoading && <Spinner className={classes.spinner} name="double-bounce" />}
      {figmaFsmResult.length > 0 && <MachinesContainer machineObjects={figmaFsmResult} />}
      <About />
    </Grid>
  );
};

export default withStyles(styles)(Main);
